// Translations
import { useLang } from "@/context/useLang"
import { useTrans } from "@/i18n"

// Auth context
import { useAuth, AuthStateStatusEnum } from "@/context/useAuth"

// UI
import { cn } from "@/lib/utils"
import { Select, SelectButton } from "./form-controls"

// Icons
import { FiChevronDown } from "@/lib/icons"

// GraphQL
import {
	Language,
	UsersUserProfileLanguageChoices,
	useUpdateUserLanguageMutation,
} from "@/api/graphql"

/**
 * LanguageSelector
 * @param param0
 * @returns
 */
export const LanguageSelector = ({ className }: { className?: string }) => {
	const { lang, setLang } = useLang()
	const t = useTrans(["common", "locale"])

	// Context
	const auth = useAuth()

	// Mutations
	const updateUserLanguage = useUpdateUserLanguageMutation()

	/**
	 * handleLanguageChange
	 * @param event
	 */
	function handleLanguageChange(event: React.FormEvent<HTMLSelectElement>) {
		// Set lang internally
		setLang(event.currentTarget.value as UsersUserProfileLanguageChoices)

		// Update user language in the API
		if (auth?.status === AuthStateStatusEnum.LOGGED_IN) {
			updateUserLanguage.mutate({
				input: {
					// TODO: The allowed language types should be the enum provided by the API
					language:
						event.currentTarget.value.toUpperCase() as Language,
				},
			})
		}
	}

	return (
		<form action="/i18n/setlang/" method="post">
			<SelectButton className={cn("relative !w-auto", className)}>
				{t(`locale:language.${lang}`)}
				<FiChevronDown className="ml-2" />
				<Select
					name="language"
					aria-label={t("common:navigation.language_selector")}
					onChange={(event) => handleLanguageChange(event)}
					value={lang}
					data-testid="language-selector"
				>
					{Object.values(UsersUserProfileLanguageChoices).map(
						(locale) => (
							<option key={locale} value={locale}>
								{t(`locale:language.${locale}`)}
							</option>
						),
					)}
				</Select>
			</SelectButton>
		</form>
	)
}
